import { render, staticRenderFns } from "./MotivasiPrestasi.vue?vue&type=template&id=4d5ac727&"
import script from "./MotivasiPrestasi.vue?vue&type=script&lang=js&"
export * from "./MotivasiPrestasi.vue?vue&type=script&lang=js&"
import style0 from "./MotivasiPrestasi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports